import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import BlogList from '../components/BlogList';
import { blogPosts } from '../utils/blogConfig';
import { BlogPost } from '../types/blog';
import Footer from '@/components/Footer';

const BlogPage: React.FC = () => {
  const navigate = useNavigate();

  const handlePostClick = (post: BlogPost) => {
    navigate(`/top-5-news/${post.id}`);
  };

  return (
    <div className="min-h-screen bg-black">
      <div className="fixed top-0 left-0 right-0 z-50 text-white">
        <Navbar />
      </div>
     
      <div className="container mx-auto pt-24 px-4 pb-16">
        <h1 className="text-4xl font-bold mb-8 text-white">
          5 Things to know before the market opens daily
        </h1>
        <BlogList 
          posts={blogPosts} 
          onPostClick={handlePostClick}
        />
      </div>
      
      <div className="text-white">
        <Footer />
      </div>
    </div>
  );
};

export default BlogPage;